// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__9nnTl","header":"notfound_header__LBqdt"};